import type { RouterRedirectionsGateProps } from "./router-redirections.type";

import { Navigate } from "react-router";

import { useGetRedirectionPath } from "./router-redirections.hook";

export const RouterRedirectionsGate = ({
  routes,
  children,
}: RouterRedirectionsGateProps) => {
  const redirectTo = useGetRedirectionPath(routes);

  if (redirectTo) return <Navigate to={redirectTo} replace />;

  return children;
};
